// extracted by css-extract-rspack-plugin
export default {"label":"label-Yhnz53","checkbox":"checkbox-TYLYq4","readonly":"readonly-ubjqG5","vcfc":"vcfc-KVZIaB"};